import React, {useState} from "react";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import useEditableTableCostCell from "../../../hooks/useEditableTableCostCell";
import useEditableTableNumberCell from "../../../hooks/useEditableTableNumberCell";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import { Checkbox, Control, Field } from "@allxsmith/bestax-bulma";
import useInlineEditButton from "../../../hooks/useInlineEditButton";


export default function RateCardRow({rateCard, onSave, onChange, index}){
    const [editable, setEditable] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();


    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "contact",
                value: e[0]
            }
        }
        onChange(toUpdate, index)
    }

    const handleHide = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        };
        onChange(toUpdate, index)
    }

    return (
        <tr>
            <td>{rateCard.name}</td>
            {useEditableTableCostCell({
                propName: "day1_2_rate",
                value: rateCard.day1_2_rate,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableCostCell({
                propName: "day3_6_rate",
                value: rateCard.day3_6_rate,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableCostCell({
                propName: "day7_27_rate",
                value: rateCard.day7_27_rate,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableCostCell({
                propName: "day_28_plus_rate",
                value: rateCard.day_28_plus_rate,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableNumberCell({
                propName: "insurance_perc",
                value: rateCard.insurance_perc,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableNumberCell({
                propName: "admin_perc",
                value: rateCard.admin_perc,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableTextAreaCell({
                propName: "description",
                value: rateCard.description,
                onChange: e => onChange(e, index),
                onSave: ()=> onSave(rateCard, () => setEditable(false)),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            <td>
                <AsyncTypeahead
                          useCache={false}
                          id="typeahead"
                          labelKey="display_name"
                          minLength={2}
                          name={"contact"}
                          onSearch={handleSearch}
                          onChange={handleContactSelect}
                          placeholder={"Search Customer"}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          isLoading={isLoading}
                          selected={
                            rateCard.contact && rateCard.contact.id ? [rateCard.contact] : []
                          }
                          disabled={!editable}
                />
            </td>
            <td>
                <Field className={"has-addons"}>
                    <Control>
                        <Checkbox
                            checked={rateCard.hide}
                            name={"hide"}
                            onChange={handleHide}
                        />
                    </Control>
                    {useInlineEditButton({
                        show: true,
                        onSave: ()=> onSave(rateCard, () => setEditable(false)),
                        editable,
                        setEditable,
                        disabled: false
                    })}
                </Field>
            </td>
        </tr>
    );
}